import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_999434b0";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_999434b0" };
/** script content **/
require("./slider.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex999434b0%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fslider%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_999434b0"],
    ctorType: "component",
    outputPath: "components/index999434b0/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
